import classnames from 'classnames'
import Link from 'components/link'
import css from './add-one.scss'

const AddOne = ({ onClick, message }) => {
  return (
    <Link
      className={classnames(css.addOneContainer, 'link-lowlight')}
      onClick={onClick}
    >
      <span className={css.addOne}>+</span>
      <span className={css.addOneMessage}>{message}</span>
    </Link>
  )
}

export default AddOne
